import { useEffect, useState } from "react";
import useData from "hooks/useData";

export function useComments(entity_id, bundle, refreshToken) {
  const [ comments, setComments ] = useState();
  const [ isLoading, setIsLoading ] = useState(true);
  const [ error, setError ] = useState('');
  const { getData } = useData();

  const path = `rest/${bundle}/${ entity_id }/comments`;

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        let result;
        try {
          result = await getData(path);
        } catch (exception) {
          console.error(exception);
          setError('De reacties konden niet worden opgehaald. Ververs de pagina of probeer het later opnieuw.');
        }
        setComments(formatThreadedComments(result.data));
        setIsLoading(false);
      }
      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ entity_id, path, refreshToken ]);

  return { comments, isLoading, error };
}

const formatThreadedComments = (comments) => {
  // Add an element with the replies to each comment.
  comments.forEach(comment => {
    if (!comment.replies) {
      comment.replies = [];
    }

    if (comment.pid) {
      const parent = comments.find(parent => comment.pid === parent.cid);
      if (!parent.replies) {
        parent.replies = [];
      }
      parent.replies.push(comment);
    }
  });

  // Remove the comments that have been moved as an element into their parent.
  comments = comments.filter(comment => comment.pid === '');

  return comments;
}

export default useComments;
